import { Button, Card, Col, Divider, Form, Input, Row, Select, Table, Tag, Tooltip } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { MdEdit, MdSend } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Authority from "../../components/Authority/Authority";
import ContactModal from "../../components/modal/contact/ContactModal";
import checkStatusUser from "../../config/UnAuthenticated";
import contactAdminService from "../../services/adminService/ContactAdminService";
const ListContact = () => {
    const [form] = Form.useForm()
    const [data, setData] = useState([]);
    const [selectRecord, setSelectRecord] = useState({});
    const [isStatusUser, setIsStatusUser] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [mode, setMode] = useState("");
    const [processedData, setProcessedData] = useState([]);
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const navigate = useNavigate();

    const handleChangeStatus = (record, mode) => {
        setIsModalOpen(true);
        setSelectRecord(record);
        setMode(mode);
    };
    const columns = [
        {
            title: "Tên",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Công ty",
            dataIndex: "company",
            key: "company",
        },
        {
            title: "Số điện thoại",
            dataIndex: "mobile",
            key: "mobile",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "Tiêu đề",
            dataIndex: "title",
            key: "title",
            render: (text) => (
                <Tooltip title={text}>
                    {text?.length > 30 ? `${text.substring(0, 30)}...` : text}
                </Tooltip>
            ),
        },
        {
            title: "Nội dung liên hệ",
            dataIndex: "content",
            key: "content",
            render: (text) => (
                <Tooltip title={text}>
                    {text?.length > 30 ? `${text.substring(0, 30)}...` : text}
                </Tooltip>
            ),

        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            align: "center",
            render: (text) => {
                let statusText = "";
                let color = "";
                switch (text) {
                    case 1:
                        statusText = "Chờ hỗ trợ";
                        color = "default";
                        break;
                    case 2:
                        statusText = "Đã tiếp nhận";
                        color = "processing";

                        break;
                    case 3:
                        statusText = "Đã xử lý";
                        color = "success";
                        break;
                    default:
                        statusText = "Chưa xác định";
                        color = "default";
                }
                return <Tag color={color}>{statusText}</Tag>;
            }
        },
        {
            title: "Nội dung phản hồi",
            dataIndex: "reply",
            key: "reply",
            render: (text) => (
                <Tooltip title={text}>
                    {text?.length > 30 ? `${text.substring(0, 30)}...` : text}
                </Tooltip>
            ),
        },
        {
            title: "Gửi email",
            dataIndex: "send_email",
            key: "send_email",
            align: "center",
            render: (text) => {
                let statusText = "";
                let color = "";
                switch (text) {

                    case null:
                        statusText = "Chưa gửi email";
                        color = "processing";
                        break;
                    case 1:
                        statusText = "Đã gửi email";
                        color = "success";
                        break;
                    default:
                        statusText = "Chưa xác định";
                        color = "default";
                }
                return <Tag color={color}>{statusText}</Tag>;
            }
        },
        {
            title: "Ngày tạo",
            dataIndex: "created_at",
            key: "created_at",
        },
        {
            title: "Ngày cập nhật",
            dataIndex: "updated_at",
            key: "updated_at",
        },
        {
            title: "Hành động",
            key: "action",
            fixed: "right",
            render: (record) => {
                return (
                    <div className="d-flex gap-2">
                        <Tooltip placement="top" title={record?.status === 3 ? "Trạng thái đã xử lý" : "Cập nhật trạng thái"}>
                            {<Button icon={<MdEdit />} disabled={record?.status === 3} className="d-flex align-items-center justify-content-center" onClick={() => handleChangeStatus(record, "status")} />}
                        </Tooltip>
                        <Tooltip placement="top" title={record?.send_email === 1 ? "Đã gửi email phản hồi" : record?.status !== 3 ? "Vui lòng xử lý để gửi email" : "Gửi email phản hồi"}>
                            <Button icon={<MdSend />} disabled={record?.send_email === 1 || record?.status !== 3} className="d-flex align-items-center justify-content-center" type="primary" onClick={() => handleChangeStatus(record, "send_email")} />
                        </Tooltip>
                    </div>
                );
            },
        },
    ];

    const fetchData = async (params) => {
        try {
            const response = await contactAdminService.getContacts(params);
            if (response?.status === 200) {
                setData(response?.data);
            } else {
                toast.warn(response?.message);
            }
        } catch (err) {
            if (checkStatusUser(err?.response?.statusText)) {
                setIsStatusUser(true);
            } else {
                toast.error(err.message);
            }
        }
    };
    useEffect(() => {
        fetchData({});
    }, []);

    useEffect(() => {
        const handleData = data?.map((item) => {
            const formatDate = (date) => moment.utc(date).format("YYYY-MM-DD HH:mm:ss");
            return {
                ...item,
                key: item.id,
                created_at: formatDate(item.created_at),
                updated_at: formatDate(item.updated_at),
            };
        });
        setProcessedData(handleData);
    }, [data]);

    const handleOkCheckStatusUser = () => {
        setIsStatusUser(false);
        localStorage.clear();
        navigate("/admin/login");
    };

    const submit = async (values) => {
        const params = {
            title: values?.title,
            email: values?.email,
            mobile: values?.mobile,
            status: values?.status,
            send_email: values?.send_email,
        };
        fetchData(params);
    }

    return (
        <div className="p-3">
            {isStatusUser && <Authority oke={handleOkCheckStatusUser} status={isStatusUser} />}

            <Card title="LIÊN HỆ" bordered={false}>
                <Form
                    form={form}
                    onFinish={submit}
                    layout="vertical"
                    initialValues={{
                        status: "",
                        send_email: 0,
                    }}
                >
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12} md={8} lg={4}>
                            <Form.Item
                                name="title"
                                label={"Tiêu đề"}
                            >
                                <Input
                                    placeholder={"Nhập tiêu đề"}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={4}>
                            <Form.Item
                                name="email"
                                label={"Email"}
                            >
                                <Input
                                    placeholder={"Nhập Email"}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={4}>
                            <Form.Item
                                name="mobile"
                                label={"Số điện thoại"}
                            >
                                <Input
                                    placeholder={"Nhập số điện thoại"}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={4}>
                            <Form.Item
                                name="status"
                                label={"Trạng thái"}
                            >
                                <Select
                                    options={[
                                        {
                                            value: "",
                                            label: "Tất cả",
                                        },
                                        {
                                            value: 1,
                                            label: "Chờ hỗ trợ",
                                        },
                                        {
                                            value: 2,
                                            label: "Đã tiếp nhận",
                                        },
                                        {
                                            value: 3,
                                            label: "Đã xử lý",
                                        },
                                    ]}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={4}>
                            <Form.Item
                                name="send_email"
                                label={"Trạng thái phản hồi"}
                            >
                                <Select
                                    options={[
                                        {
                                            value: 0,
                                            label: "Tất cả",
                                        },
                                        {
                                            value: 1,
                                            label: "Đã gửi email",
                                        },
                                        {
                                            value: 2,
                                            label: "Chưa gửi email",
                                        },
                                    ]}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={4}>
                            <Form.Item
                                name="submit"
                                label={" "}
                            >
                                <Button type="primary" htmlType="submit">Tìm kiếm</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <Divider />
                <Table
                    columns={columns}
                    scroll={{ x: "max-content" }}
                    dataSource={processedData}
                />
            </Card>

            <ContactModal handleCancel={handleCancel} isModalOpen={isModalOpen} refetch={fetchData} selectRecord={selectRecord} mode={mode} />
        </div>
    );
};

export default ListContact;
